/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon16Solid = forwardRef('FoodDrinkCupStrawIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.25 1.875H9.516L9.233 4h2.212c.742 0 1.32.643 1.243 1.38l-.848 8.053A1.75 1.75 0 0 1 10.1 15H5.9a1.75 1.75 0 0 1-1.74-1.567l-.848-8.052A1.25 1.25 0 0 1 4.555 4h2.912l.329-2.465a1.625 1.625 0 0 1 1.61-1.41h2.844a.875.875 0 0 1 0 1.75Z" })));
});
